export enum AdminSourceSystem {
    CGS = 'CGS',
    COMPASS = 'COMPASS'
}